import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import { lastValueFrom, Subject, takeUntil } from 'rxjs'
import { ProductService } from 'src/app/services/api/product.service'
import { DialogAsignarMenuComponent } from './dialog-asignar-menu/dialog-asignar-menu.component'
import { DialogReplicarMenusComponent } from './dialog-replicar-menus/dialog-replicar-menus.component'
@Component({
  selector: 'app-servicios-alimentos',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './servicios-alimentos.component.html',
  styleUrls: ['./servicios-alimentos.component.scss']
})
export class ServiciosAlimentosComponent implements OnInit, OnDestroy {
  private _unsubscribeOnDestroy$ = new Subject<boolean>()
  productGroupedServices: any = []
  selectProveedor: string | null = null
  selectCategoria: string | null = null
  selectProducto: string | null = null
  selectStatus: string | null = null
  uniqueProviderNames: string[] = []
  uniqueServiceCategories: string[] = []
  arrayProducto: string[] = []
  uniqueYearProducts: string[] = []
  selectYear: string = new Date().getFullYear().toString()

  displayedColumns = [
    'yearProduct',
    'nombreServicio',
    'nombreProducto',
    'serviceDay',
    // 'estadoServicio',
    'categoriaServicio',
    'nombreProveedor',
    'menu',
    'asignar',
  ]

  dataSource = new MatTableDataSource<any>()
  isLoading = true

  paginator!: MatPaginator
  @ViewChild(MatPaginator) set matPaginator (paginator: MatPaginator) {
    this.paginator = paginator
    this.dataSource.paginator = paginator
  }

  sort!: MatSort
  @ViewChild(MatSort, { static: false }) set matSort (sort: MatSort) {
    this.sort = sort
    this.dataSource.sort = sort
  }

  constructor (
    public matDialog: MatDialog,
    private readonly productService: ProductService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  ngOnInit () {
    this.getAllServiciosAlimentos()
  }

  ngOnDestroy (): void {
    this._unsubscribeOnDestroy$.next(true)
    this._unsubscribeOnDestroy$.complete()
  }

  async getAllServiciosAlimentos () {
    let serviciosAgrupado = (
      await lastValueFrom(
        this.productService.queryGetAllServicesFromAgrupadoByType({
          tipoServicio: 'ALIMENTOSYBEBIDAS'
        })
      )
    ).getAllServicesFromAgrupadoByType

    serviciosAgrupado = serviciosAgrupado.filter(
      productService =>
        (productService?.categoriaServicio === 'EXPLORANDESCOCINA' ||
          productService?.categoriaServicio === 'EXPLORANDESPICNIC') &&
        productService?.nombreProveedor === 'EXPLORANDES CUSCO'
    )

    const filteredProviderNames = serviciosAgrupado
      .map(productService => productService?.nombreProveedor)
      .filter(Boolean)
    const filteredServicesCategory = serviciosAgrupado
      .map(productService => productService?.categoriaServicio)
      .filter(Boolean)
    const filteredYearProducts = serviciosAgrupado
      .map(productService => productService?.yearProduct)
      .filter(Boolean)

    this.uniqueProviderNames = [...new Set(filteredProviderNames)].sort()
    this.uniqueServiceCategories = [...new Set(filteredServicesCategory)].sort()
    this.uniqueYearProducts = [...new Set(filteredYearProducts)].sort(
      (a, b) => Number(b) - Number(a)
    )

    const producto = serviciosAgrupado
      .map((productService: any) => productService.nombreProducto)
      .filter((nombreProducto: any) => nombreProducto != null)
    this.arrayProducto = [...new Set(producto)]

    this.productGroupedServices = serviciosAgrupado
    this.dataSource.data = serviciosAgrupado
    this.dataSource.paginator = this.paginator
    this.dataSource.filter = ''

    this.applyFilterSelect()
    this.isLoading = false
    this.cdRef.markForCheck()
  }

  applyFilter (event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSource.filter = filterValue.trim().toLowerCase()
  }

  applyFilterSelect () {
    let filteredProductGroupedServices: any = this.productGroupedServices

    if (this.selectProveedor) {
      filteredProductGroupedServices = filteredProductGroupedServices?.filter(
        (productService: any) =>
          productService.nombreProveedor === this.selectProveedor
      )
    }
    if (this.selectCategoria) {
      filteredProductGroupedServices = filteredProductGroupedServices?.filter(
        (productService: any) =>
          productService.categoriaServicio === this.selectCategoria
      )
    }
    if (this.selectProducto) {
      filteredProductGroupedServices = filteredProductGroupedServices?.filter(
        (productService: any) =>
          productService.nombreProducto === this.selectProducto
      )
    }
    if (this.selectYear) {
      filteredProductGroupedServices = filteredProductGroupedServices?.filter(
        (productService: any) => productService.yearProduct == this.selectYear
      )
    }

    if (this.selectStatus) {
      if (this.selectStatus === 'asignado')
        filteredProductGroupedServices = filteredProductGroupedServices?.filter(
          (productService: any) => productService.menu !== null
        )
      else
        filteredProductGroupedServices = filteredProductGroupedServices?.filter(
          (productService: any) => productService.menu === null
        )
    }

    this.dataSource.data = filteredProductGroupedServices
  }

  openDialogAsignarMenuComponent (productService: any) {
    console.log(productService)
    let dialogConfig = new MatDialogConfig()

    dialogConfig.data = {
      serviceId: productService.id,
      nombreServicio: productService.nombreServicio
    }
    dialogConfig.width = '30rem'

    let dialogRef = this.matDialog.open(
      DialogAsignarMenuComponent,
      dialogConfig
    )

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeOnDestroy$))
      .subscribe(result => {
        if (result == 1) {
          this.isLoading = true
          this.getAllServiciosAlimentos()
          this.cdRef.markForCheck()
        }
      })
  }

  openDialogReplicarMenus () {
    console.log({
      allGroupedServices: this.productGroupedServices
    })
    const dialogConfig = new MatDialogConfig<{
      allGroupedServices: any[]
    }>()
    dialogConfig.data = {
      allGroupedServices: this.productGroupedServices
    }
    dialogConfig.width = '30rem'

    const dialogRef = this.matDialog.open(
      DialogReplicarMenusComponent,
      dialogConfig
    )

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeOnDestroy$))
      .subscribe(result => {
        if (result?.alteredServices > 0) {
          this.isLoading = true
          this.getAllServiciosAlimentos()
          this.cdRef.markForCheck()
        }
      })
  }
}
